import {
    TaskSubtaskStatusMapping,
    TaskStatusFlowMode,
    TaskStatusFlowModeStatusMapping,
    TaskType,
    TaskTypeDueDate,
} from "../types";
import appClient, { ResultApi } from "../../common/services/AppClient";
import { endpoints } from "../../../config";

export default class TaskTypesService {
    async getTaskTypesForProject(
        projectId?: string,
    ): Promise<ResultApi<TaskType[]>> {
        const queryParams = projectId ? `?projectId=${projectId}` : "";
        const url = `${endpoints.tasksUrl}tasktypes${queryParams}`;
        return appClient.get<TaskType[]>(url);
    }

    createTaskType(
        name: string,
        assignee: string | null | undefined,
        code: string,
        projectId: string,
        canChangeStatusManually: boolean,
        dueDate: TaskTypeDueDate | null,
        reminderDays: number | null,
        statusFlowMode: TaskStatusFlowMode = "standard",
    ) {
        const request = {
            name,
            assignee,
            projectId,
            code,
            canChangeStatusManually,
            dueDate,
            reminderDays,
            statusFlowMode,
        };
        const url = endpoints.tasksUrl + "tasktypes/new";
        return appClient.post<string>(url, request);
    }

    editTaskType(
        typeId: string,
        name: string,
        assignee: string | null | undefined,
        code: string,
        canChangeStatusManually: boolean,
        distinctSubtaskStatuses: boolean,
        dueDate: TaskTypeDueDate | null,
        reminderDays: number | null,
        statusFlowMode: TaskStatusFlowMode,
        subtaskStatusMappings?: TaskSubtaskStatusMapping[],
    ) {
        const request = {
            typeId,
            name,
            assignee,
            code,
            canChangeStatusManually,
            distinctSubtaskStatuses,
            dueDate,
            reminderDays,
            statusFlowMode,
            subtaskStatusMappings,
        };
        const url = endpoints.tasksUrl + "tasktypes/edit";
        return appClient.update(url, request);
    }

    updateStatusFlowMode(
        typeId: string,
        statusFlowMode: TaskStatusFlowMode,
        statusMappings?: TaskStatusFlowModeStatusMapping[],
    ) {
        const request = {
            typeId,
            statusFlowMode,
            statusMappings,
        };
        const url = endpoints.tasksUrl + "tasktypes/statusflowmode";
        return appClient.update<string>(url, request);
    }

    toggleTaskType(typeId: string) {
        const url = endpoints.tasksUrl + `tasktypes/toggle/${typeId}`;
        return appClient.update(url);
    }

    deleteTaskType(typeId: string) {
        const url = endpoints.tasksUrl + `tasktypes/delete/${typeId}`;
        return appClient.post(url);
    }
}
